import Vue from 'vue';
import Vuex from 'vuex';

// import { getMenus } from '@/api/user.js';

import User from './modules/User'; // 用户
import LeftMenu from './modules/LeftMenu'; // 左侧菜单
import Novelty from './modules/Novelty'; // 标准查新
import Cart from './modules/Cart'; // 购物车
import Settings from './modules/Settings'; //设置

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		cpage: {
			isOpenFloat: true,
			isOpenTotop: true,
			fullClass: '' // is-full-on
		},
		isCollapse: false,
		menuTree: [],
		pic: 'user',
		search: {
			keyword: '' // 搜索关键词
		},

		shop: {
			doc: {
				pdf: ''
			}
		}
	},
	getters: {
		gpic(state) {
			return state.pic;
		},

		// 返回页面的配置信息
		cpage(state) {
			return state.cpage;
		},

		// 搜索关键词
		skeyword(state) {
			return state.search.keyword;
		},

		// 当前预览的PDF
		gdoc(state) {
			return state.shop.doc;
		}
	},
	mutations: {
		changeCollapse(state) {
			state.isCollapse = !state.isCollapse;
		},
		setMenuTree(state, menus) {
			state.menuTree = menus;
		},

		// 设置页面参数
		setPage(state, pm) {
			for (let k in pm) {
				state.cpage[k] = pm[k];
			}
		},

		// 设置默认搜索关键词
		setSkeyword(state, keyword) {
			state.search.keyword = keyword;
		},

		// 设定文档相关的运行数据
		setDoc(state, doc) {
			state.shop.doc = doc;
		}
	},
	actions: {
		getMenuTree({ commit }) {
			// return new Promise((resolve, reject) => {
			// 	getMenus()
			// 		.then(res => {
			// 			console.log('menusTree:', res);
			// 			commit('setMenuTree', res.data);
			// 			resolve();
			// 		})
			// 		.catch(err => {
			// 			reject(err);
			// 		});
			// });
		},

		// 设置页面参数
		setPage({ commit }, pm) {
			commit('setPage', pm);
		},

		// 修改关键词
		setSkeyword(context, keyword) {
			context.commit('setSkeyword', keyword);
		},

		// 设置文档相关的运行数据
		setDoc(context, doc) {
			context.commit('setDoc', doc);
		}
	},
	modules: {
		LeftMenu,
		Novelty,
		User,
		Cart,
		Settings
	}
});
